import React from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { v5 as uuidv5 } from 'uuid';
import Logger from '../../utils/logger';
import { TraceProvider } from '../../utils/instrumentation';
import { registerTelemetryConfigured } from '../../store/system/systemSlice';

const APMHandler: React.FC<{ children: React.ReactNode }> = ({ children }) => {
	const dispatch = useAppDispatch();
	const userId = useAppSelector((state) => state.user.id);
	const userName = useAppSelector((state) => state.user.name);
	const telemetryConfigured = useAppSelector((state) => state.system.telemetryConfigured);

	// user is verified by a combination of their name + a hashed ID
	const telemetryEnabled: string = import.meta.env.VITE_ENABLE_TELEMETRY || 'false';
	if (telemetryEnabled == 'true' && !telemetryConfigured) {
		const sessionId = uuidv5(userId, uuidv5.DNS);
		Logger.debug(`Telemetry Enabled, session ID: ${sessionId}`);
		TraceProvider(userName, sessionId)
			.then(() => {
				dispatch(registerTelemetryConfigured());
			})
			.catch((e) => {
				Logger.warn(`Failed to set up telemetry: ${e}`);
			});
	}

	return <>{children}</>;
};

export default APMHandler;
